module.exports = __webpack_public_path__ + "static/hewanbesar-71e7d2336e4b0592040cb3e338770063.png";